import {
    AsyncHandlingOverviewRestDto,
    PagedAsyncHandlingOverviewRestDto,
    PagingMetadataRestDto
} from "@/api/pharma-master-async-handling/models";

export class PagedAsyncHandlingOverviewRestDtoModel implements PagedAsyncHandlingOverviewRestDto {
    paging_metadata: PagingMetadataRestDto;
    results: AsyncHandlingOverviewRestDto[];

    constructor(paging_metadata: PagingMetadataRestDto, results: AsyncHandlingOverviewRestDto[]) {
        this.paging_metadata = paging_metadata;
        this.results = results;
    }

    public static createWithDefaults(): PagedAsyncHandlingOverviewRestDtoModel {
        return new this({
            total_elements: 0,
            total_pages: 0,
            page_number: 0,
            page_element_count: 0,
            size: 20,
            is_first: true,
            is_last: true
        }, []);
    }
}
